import type { MultiPrimaryItem } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';

export const normalizeMultiPrimaryDefaults = (
	// FIX: Explicitly allow strings in the input array type
	input?:
		| Array<MultiPrimaryItem | string>
		| MultiPrimaryItem
		| string
		| null
		| undefined
): MultiPrimaryItem[] => {
	if (!input) return [];

	if (Array.isArray(input)) {
		return (
			input
				// FIX: Explicitly set return type to 'MultiPrimaryItem | null'
				// This solves the "Type is not assignable" predicate error.
				.map((item, idx): MultiPrimaryItem | null => {
					if (typeof item === 'string') {
						// FIX: Now valid because input array allows strings
						if (!item.trim()) return null;
						return {
							id: item,
							name: item,
							isPrimary: idx === 0,
							fieldName: undefined
						};
					}

					// Handle Object inputs
					// Filter out items that have NO id and NO name
					if (!item.id && !item.name) {
						return null;
					}

					return {
						id: item.id || '',
						name: item.name ?? '',
						isPrimary: idx === 0 ? true : (item.isPrimary ?? false),
						fieldName: item.fieldName || undefined
					};
				})
				.filter((item): item is MultiPrimaryItem => item !== null)
		);
	}

	// Single String Case
	if (typeof input === 'string') {
		return input.trim()
			? [{ id: input, name: input, isPrimary: true, fieldName: undefined }]
			: [];
	}

	// Single Object Case
	if (!input.id && !input.name) {
		return [];
	}

	return [
		{
			id: input.id || '',
			name: input.name ?? '',
			isPrimary: true,
			fieldName: input.fieldName || undefined
		}
	];
};
